import classNames from "classnames"
import { useRouter } from "next/router";
import { IconArrowLeft } from "@/components/icons/icon-arrow-left"
import { SellerPageRouter } from "@/modules/seller/page-router.props";

export const AppHeader = ({ headerClassName, onBackClick, title, fixedHeader, RightComponent, backNavigation }: {
  headerClassName?: string;
  onBackClick?: () => void;
  title?: string;
  fixedHeader?: boolean;
  RightComponent?: React.ReactNode;
  backNavigation?: boolean;
}) => {
  const router: SellerPageRouter = useRouter();
  return (
    <header
      className={classNames(
        { "fixed max-w-screen-mobile w-full flex items-center p-4 bg-custombg border-b border-b-primary z-10": fixedHeader },
        headerClassName
      )}
    // style={{ backgroundColor: '#FFFFFF', color: '#000000' }}
    >
      {backNavigation && (
        <IconArrowLeft
          onClick={() => (onBackClick ? onBackClick() : router.back())}
          className="cursor-pointer z-10"
          id="header-back-btn"
          data-testid="header-back-btn"
        />
      )}
      {title && (
        <h1
          className={classNames(
            "flex-1 text-center text-md font-bold text-primary",
            {
              "mr-6": !RightComponent,
            }
          )}
          id="container-title"
          data-testid="container-title"
        >
          {title}
        </h1>
      )}
      {RightComponent && RightComponent}
    </header>
  )
}